'use client';

import { type FC, type ReactNode, useState, useEffect } from 'react';
import config from 'shared/config';
interface DevtoolsModule {
  RechartsDevtoolsContext: FC<{
    children: ReactNode;
  }>;
  RechartsDevtoolsPortal: FC;
}
const ChartDevtoolsWrapper = ({
  children,
  useDebugTools
}: Readonly<{
  children: ReactNode;
  useDebugTools?: boolean;
}>): ReactNode => {
  const [devtools, setDevtools] = useState<DevtoolsModule | null>(null);
  useEffect(() => {
    if (config('APP_ENV') !== 'development' || useDebugTools !== true) return;
    void import('@recharts/devtools').then(m => {
      setDevtools({
        RechartsDevtoolsContext: m.RechartsDevtoolsContext,
        RechartsDevtoolsPortal: m.RechartsDevtoolsPortal
      });
    });
  }, [useDebugTools]);
  if (devtools === null) {
    return <>{children}</>;
  }
  const {
    RechartsDevtoolsContext,
    RechartsDevtoolsPortal
  } = devtools;
  return <RechartsDevtoolsContext>
      {children}
      <RechartsDevtoolsPortal />
    </RechartsDevtoolsContext>;
};
export default ChartDevtoolsWrapper;